import { Button } from '@sparemin/blockhead';
import React from 'react';

import useDownloadAllButton from './useDownloadAllButton';

const HeaderDownloadAllButton: React.FC = () => {
  const { content, ...props } = useDownloadAllButton();

  return (
    <Button {...props} size="small">
      {content}
    </Button>
  );
};

export default HeaderDownloadAllButton;
